import { render, staticRenderFns } from "./OfferEvaluationPageCustomerOrderReassignACOM.vue?vue&type=template&id=345e0c96&"
import script from "./OfferEvaluationPageCustomerOrderReassignACOM.vue?vue&type=script&lang=ts&"
export * from "./OfferEvaluationPageCustomerOrderReassignACOM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('345e0c96')) {
      api.createRecord('345e0c96', component.options)
    } else {
      api.reload('345e0c96', component.options)
    }
    module.hot.accept("./OfferEvaluationPageCustomerOrderReassignACOM.vue?vue&type=template&id=345e0c96&", function () {
      api.rerender('345e0c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/OfferEvaluationPageCustomerOrderReassignACOM.vue"
export default component.exports